import { useState } from "react";
import userStore from "../zustand/userStore";
import { useDispatch } from "react-redux";
import { partnershipRegistrationThunk } from "../features/ticketing-app/redux/ticketingSlice";

const allModules = [
  {
    id: 2,
    name: "Question Paper",
  },
  {
    id: 3,
    name: "Time Table",
  },
  {
    id: 4,
    name: "Academic Calendar",
  },
  {
    id: 5,
    name: "Teachers Planner",
  },
  {
    id: 1,
    name: "Event Organiser",
  },
  {
    id: 6,
    name: "Documents",
  },
  //   {
  //     id: 7,
  //     name: "Olympiads & Quiz",
  //   },
  //   {
  //     id: 10,
  //     name: "Create Teachers/Users",
  //   },

  //   {
  //     id: 11,
  //     name: "Become Our Partner and Earn",
  //   },
  //   {
  //     id: 12,
  //     name: "Apply for Grants & Sponsorships",
  //   },
];

const initialState = {
  personName: "",
  contactNumber: "",
  email: "",
  address: "",
  profession: "",
  workType: "",
  selectedFeatures: [],
};

const styles = {
  page: {
    background:
      "linear-gradient(135deg, #e8f4fd 0%, #f0f7ff 50%, #e8f0fe 100%)",
    padding: "32px 16px",
  },
  card: {
    maxWidth: 820,
    margin: "0 auto",
    background: "#ffffff",
    borderRadius: 20,
    boxShadow: "0 8px 48px rgba(37,99,168,0.12)",
    overflow: "hidden",
  },
  header: {
    background: "linear-gradient(135deg, #1a3a5c 0%, #2563a8 100%)",
    padding: "20px 28px",
    color: "#fff",
    height: "auto",
  },
  headerTitle: {
    margin: "0 0 8px",
    fontSize: 22,
    fontWeight: 700,
    //fontFamily: "'Georgia', serif",
  },
  headerSub: {
    margin: 0,
    fontSize: 13,
    opacity: 0.82,
    //fontFamily: "'Verdana', sans-serif",
  },
  formBody: { padding: "36px 40px" },
  sectionBlock: {
    borderLeft: "4px solid #2563a8",
    paddingLeft: 20,
    marginBottom: 36,
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: "#2563a8",
    letterSpacing: "0.1em",
    //fontFamily: "'Verdana', sans-serif",
    margin: "0 0 18px",
  },
  row: { display: "flex", flexWrap: "wrap", gap: 16, marginTop: 14 },
  col12: { flex: "1 1 100%" },
  col6: { flex: "1 1 calc(50% - 8px)", minWidth: 200 },
  label: {
    display: "block",
    fontSize: 13,
    fontWeight: 600,
    color: "#374151",
    marginBottom: 5,
    //fontFamily: "'Verdana', sans-serif",
  },
  input: {
    width: "100%",
    boxSizing: "border-box",
    padding: "10px 14px",
    fontSize: 14,
    border: "1.5px solid #c8d8ea",
    borderRadius: 8,
    background: "#ffffff",
    color: "#111827",
    outline: "none",
    //fontFamily: "'Georgia', serif",
  },
  inputFocus: {
    borderColor: "#2563a8",
    background: "#ffffff",
    boxShadow: "0 0 0 3px rgba(37,99,168,0.10)",
  },
  select: {
    width: "100%",
    boxSizing: "border-box",
    padding: "10px 14px",
    fontSize: 14,
    border: "1.5px solid #c8d8ea",
    borderRadius: 8,
    background: "#ffffff",
    color: "#111827",
    outline: "none",
    //fontFamily: "'Georgia', serif",
    cursor: "pointer",
  },
  textarea: {
    width: "100%",
    boxSizing: "border-box",
    padding: "10px 14px",
    fontSize: 14,
    border: "1.5px solid #c8d8ea",
    borderRadius: 8,
    background: "#ffffff",
    color: "#111827",
    outline: "none",
    //fontFamily: "'Georgia', serif",
    resize: "vertical",
    minHeight: 80,
  },
  star: { color: "#dc2626", marginLeft: 2 },
  reqTypeLabel: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    border: "1.5px solid #dce8f5",
    borderRadius: 8,
    padding: "10px 14px",
    marginBottom: 8,
    cursor: "pointer",
    fontSize: 14,
    background: "#f8fbff",
    color: "#111827",
    //fontFamily: "'Georgia', serif",
  },
  reqTypeLabelSelected: {
    border: "1.5px solid #2563a8",
    background: "#eff6ff",
    fontWeight: 600,
  },
  checkInput: {
    width: 16,
    height: 16,
    marginTop: 2,
    accentColor: "#2563a8",
    cursor: "pointer",
    flexShrink: 0,
  },
  btnPrimary: {
    background: "linear-gradient(90deg, #1a3a5c 0%, #2563a8 100%)",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    fontSize: 15,
    fontWeight: 700,
    padding: "13px 40px",
    cursor: "pointer",
    //fontFamily: "'Verdana', sans-serif",
    letterSpacing: "0.04em",
    boxShadow: "0 4px 16px rgba(37,99,168,0.20)",
  },
  btnSecondary: {
    background: "#fff",
    color: "#374151",
    border: "1.5px solid #c8d8ea",
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 600,
    padding: "13px 28px",
    cursor: "pointer",
    //fontFamily: "'Verdana', sans-serif",
  },
  toast: {
    position: "fixed",
    bottom: 30,
    right: 30,
    background: "#166534",
    color: "#fff",
    borderRadius: 10,
    padding: "14px 26px",
    fontWeight: 600,
    fontSize: 14,
    boxShadow: "0 4px 20px rgba(0,0,0,0.18)",
    zIndex: 9999,
    //fontFamily: "'Verdana', sans-serif",
    animation: "slideUp 0.3s ease",
  },
  featureNote: {
    fontSize: 12,
    color: "#6b7280",
    //fontFamily: "'Verdana', sans-serif",
    marginBottom: 10,
    marginTop: -8,
  },
  moduleCard: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    border: "1.5px solid #dce8f5",
    borderRadius: 8,
    padding: "10px 14px",
    marginBottom: 0,
    cursor: "pointer",
    fontSize: 13,
    background: "#f8fbff",
    color: "#111827",
    //fontFamily: "'Verdana', sans-serif",
    flex: "1 1 calc(50% - 8px)",
    minWidth: 200,
    boxSizing: "border-box",
    transition: "all 0.15s ease",
  },
  moduleCardSelected: {
    background: "#eff6ff",
    fontWeight: 600,
  },
  moduleCardDisabled: {
    opacity: 0.4,
    cursor: "not-allowed",
  },
  moduleDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    flexShrink: 0,
  },
  moduleEmoji: {
    fontSize: 16,
    flexShrink: 0,
  },
};

/* ── Focusable primitives ── */
function FocusInput({ style, ...props }) {
  const [focused, setFocused] = useState(false);
  return (
    <input
      {...props}
      style={{
        ...styles.input,
        ...style,
        ...(focused ? styles.inputFocus : {}),
      }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
    />
  );
}

function FocusTextarea({ style, ...props }) {
  const [focused, setFocused] = useState(false);
  return (
    <textarea
      {...props}
      style={{
        ...styles.textarea,
        ...style,
        ...(focused ? styles.inputFocus : {}),
      }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
    />
  );
}

/* ── Main component ── */
export default function PartnerRequestForm({ isOpen, onClose }) {
  const [form, setForm] = useState(initialState);
  const [showToast, setShowToast] = useState(false);
  const userData = userStore((state) => state.user);
  const dispatch = useDispatch();
  const today = new Date().toISOString().split("T")[0];

  const [dateToshow, setDateToShow] = useState(today);
  const update = (field) => (e) =>
    setForm((p) => ({ ...p, [field]: e.target.value }));

  const toggleFeature = (module) => {
    setForm((p) => {
      const already = p.selectedFeatures.some((f) => f.id === module.id);
      if (already) {
        return {
          ...p,
          selectedFeatures: p.selectedFeatures.filter(
            (f) => f.id !== module.id,
          ),
        };
      }
      if (p.selectedFeatures.length >= 3) return p;
      return {
        ...p,
        selectedFeatures: [
          ...p.selectedFeatures,
          { id: module.id, name: module.name.trim() },
        ],
      };
    });
  };

  if (!isOpen) return null;

  const validateForm = () => {
    const errors = [];

    if (!form.personName.trim()) errors.push("Name of the Person");
    if (!/^\d{10}$/.test(String(form.contactNumber)))
      errors.push("Contact Number must be exactly 10 digits");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      errors.push("Email Id is not a valid email address");
    if (!form.address.trim()) errors.push("Address");
    if (!form.profession.trim()) errors.push("Profession");
    if (!form.workType) errors.push("Work Type (Part Time / Full Time)");
    if (form.selectedFeatures.length !== 3)
      errors.push("Please select exactly 3 features of the School Module");

    return errors;
  };

  const handleSubmit = async () => {
    const errors = validateForm();

    if (errors.length > 0) {
      alert(
        "Please correct the following:\n\n" +
          errors.map((e, i) => `${i + 1}. ${e}`).join("\n"),
      );
      return;
    }

    const finalData = {
      school_user_id: userData?.admin_id,
      "Partner Request": {
        personName: form.personName,
        contactNumber: form.contactNumber,
        email: form.email,
        address: form.address,
        profession: form.profession,
        workType: form.workType,
        selectedFeatures: form.selectedFeatures,
      },
    };

    console.log("finalData", JSON.stringify(finalData));
    const action = await dispatch(partnershipRegistrationThunk(finalData));
    console.log("action", JSON.stringify(action));

    if (partnershipRegistrationThunk.fulfilled.match(action)) {
      const message =
        action.payload?.message ||
        "Partnership  request submitted successfully!";
      alert(message);
      window.location.reload();
    }

    if (partnershipRegistrationThunk.rejected.match(action)) {
      const errorMsg =
        action.payload?.message || "Something went wrong. Please try again.";
      alert(errorMsg);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        padding: "16px",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "16px",
          padding: 0,
          maxWidth: "900px",
          width: "95%",
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={styles.page}>
          <style>{`
            @keyframes slideUp { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }
            input[type="radio"]    { accent-color:#2563a8; width:17px; height:17px; cursor:pointer; }
            input[type="checkbox"] { accent-color:#2563a8; }
            select option          { background:#fff; color:#111827; }
          `}</style>

          <div style={styles.card}>
            {/* ── HEADER ── */}
            <div style={styles.header}>
              <h1 style={styles.headerTitle}>
                Request Form to Become Our Partner
              </h1>
              <p style={styles.headerSub}>
                Please fill in all required details accurately. Submission does
                not guarantee approval.
              </p>
            </div>

            <div style={styles.formBody}>
              <div style={styles.sectionBlock}>
                <p style={styles.sectionTitle}>Partner Information</p>

                {/* 1. Name */}
                <div style={{ ...styles.row, marginTop: 0 }}>
                  <div style={styles.col12}>
                    <label style={styles.label}>
                      1. Name of the Person <span style={styles.star}>*</span>
                    </label>
                    <FocusInput
                      type="text"
                      placeholder="Full name"
                      value={form.personName}
                      onChange={update("personName")}
                    />
                  </div>
                </div>

                {/* 2. Contact & 3. Email */}
                <div style={styles.row}>
                  <div style={styles.col6}>
                    <label style={styles.label}>
                      2. Contact Number <span style={styles.star}>*</span>
                    </label>
                    <FocusInput
                      type="text"
                      inputMode="numeric"
                      maxLength={10}
                      placeholder="+91 XXXXX XXXXX"
                      value={form.contactNumber}
                      onChange={update("contactNumber")}
                    />
                  </div>
                  <div style={styles.col6}>
                    <label style={styles.label}>
                      3. Email Id <span style={styles.star}>*</span>
                    </label>
                    <FocusInput
                      type="email"
                      placeholder="you@example.com"
                      value={form.email}
                      onChange={update("email")}
                    />
                  </div>
                </div>

                {/* 4. Address */}
                <div style={styles.row}>
                  <div style={styles.col12}>
                    <label style={styles.label}>
                      4. Address <span style={styles.star}>*</span>
                    </label>
                    <FocusTextarea
                      placeholder="Your full address"
                      value={form.address}
                      onChange={update("address")}
                      style={{ minHeight: 70 }}
                    />
                  </div>
                </div>

                {/* 5. Profession */}
                <div style={styles.row}>
                  <div style={styles.col12}>
                    <label style={styles.label}>
                      5. Profession <span style={styles.star}>*</span>
                    </label>
                    <FocusInput
                      type="text"
                      placeholder="e.g. Teacher, Entrepreneur, Consultant"
                      value={form.profession}
                      onChange={update("profession")}
                    />
                  </div>
                </div>

                {/* 6. Part Time / Full Time */}
                <div style={styles.row}>
                  <div style={styles.col12}>
                    <label style={styles.label}>
                      6. Do You want to work Part Time or Full Time?{" "}
                      <span style={styles.star}>*</span>
                    </label>
                    <div
                      style={{
                        ...styles.row,
                        marginTop: 8,
                        rowGap: 6,
                        columnGap: 16,
                      }}
                    >
                      {["Part Time", "Full Time"].map((type) => (
                        <div key={type} style={styles.col6}>
                          <label
                            style={{
                              ...styles.reqTypeLabel,
                              ...(form.workType === type
                                ? styles.reqTypeLabelSelected
                                : {}),
                            }}
                          >
                            <input
                              type="radio"
                              name="workType"
                              value={type}
                              checked={form.workType === type}
                              onChange={(e) =>
                                setForm((p) => ({
                                  ...p,
                                  workType: e.target.value,
                                }))
                              }
                            />
                            &nbsp; {type}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* 7. School Module Features */}
                <div style={{ ...styles.row, marginTop: 16 }}>
                  <div style={styles.col12}>
                    <label style={styles.label}>
                      7. Select any three features of School Module that you
                      have explored so far. <span style={styles.star}>*</span>
                    </label>
                    <p style={styles.featureNote}>
                      Select exactly 3 ({form.selectedFeatures.length}/3
                      selected)
                    </p>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 10,
                        marginTop: 4,
                      }}
                    >
                      {allModules.map((module) => {
                        const isChecked = form.selectedFeatures.some(
                          (f) => f.id === module.id,
                        );
                        const isDisabled =
                          !isChecked && form.selectedFeatures.length >= 3;

                        return (
                          <label
                            key={module.id}
                            style={{
                              ...styles.moduleCard,
                              ...(isChecked ? styles.moduleCardSelected : {}),
                              ...(isDisabled ? styles.moduleCardDisabled : {}),
                              border: `1.5px solid ${isChecked ? (module.color ?? "#2563a8") : "#dce8f5"}`,
                              background: isChecked
                                ? `${module.color ?? "#2563a8"}18`
                                : "#f8fbff",
                            }}
                            onClick={
                              isDisabled
                                ? undefined
                                : () => toggleFeature(module)
                            }
                          >
                            {/* Checkbox */}
                            <input
                              type="checkbox"
                              checked={isChecked}
                              disabled={isDisabled}
                              onChange={() => {}}
                              style={{
                                ...styles.checkInput,
                                accentColor: module.color,
                              }}
                            />
                            &nbsp;
                            {/* Color dot or emoji */}
                            {module.emoji ? (
                              <span style={styles.moduleEmoji}>
                                {module.emoji}
                              </span>
                            ) : (
                              <span
                                style={{
                                  ...styles.moduleDot,
                                  background: module.color,
                                }}
                              />
                            )}
                            {/* Name */}
                            <span
                              style={{
                                fontSize: module.nameFontSize || 13,
                                fontWeight: isChecked ? 600 : 400,
                                color: isChecked ? module.color : "#374151",
                                //fontFamily: "'Verdana', sans-serif",
                                lineHeight: 1.4,
                              }}
                            >
                              {module.name.trim()}
                              {module.comingSoon && (
                                <span
                                  style={{
                                    marginLeft: 6,
                                    fontSize: 10,
                                    background: "#f3f4f6",
                                    color: "#6b7280",
                                    borderRadius: 4,
                                    padding: "1px 6px",
                                    fontWeight: 500,
                                  }}
                                >
                                  Coming Soon
                                </span>
                              )}
                              {module.subtitle && (
                                <span
                                  style={{
                                    display: "block",
                                    fontSize: 11,
                                    color: "#6b7280",
                                    fontWeight: 400,
                                    marginTop: 2,
                                  }}
                                >
                                  {module.subtitle}
                                </span>
                              )}
                            </span>
                          </label>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <label>
                  <strong>Date</strong>
                </label>
                <FocusInput
                  type="date"
                  value={dateToshow}
                  onChange={(e) => setDateToShow(e.target.value)}
                />
              </div>

              {/* ── BUTTONS ── */}
              <div
                style={{
                  display: "flex",
                  gap: 14,
                  flexWrap: "wrap",
                  marginTop: 8,
                }}
              >
                <button style={styles.btnPrimary} onClick={handleSubmit}>
                  Submit Application
                </button>
                <button
                  style={styles.btnSecondary}
                  onClick={() => {
                    onClose();
                    setForm(initialState);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>

          {showToast && (
            <div style={styles.toast}>
              ✅ Form submitted! Check the browser console for details.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
